var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTrendingFilledRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Trending  Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M9.3347 12.333H13.9992C14.3411 12.333 14.6229 12.0756 14.6614 11.7441L14.6659 11.6663V6.99967C14.6659 6.63148 14.3674 6.33301 13.9992 6.33301C13.6573 6.33301 13.3755 6.59037 13.337 6.92193L13.3325 6.99967L13.332 10.057L8.47059 5.19494C8.23042 4.95476 7.85255 4.93613 7.59101 5.13915L7.52819 5.19453L5.99752 6.72254L2.47213 3.19602C2.21182 2.93563 1.78971 2.93556 1.52932 3.19587C1.28896 3.43616 1.27041 3.81431 1.47372 4.07587L1.52917 4.13868L5.52556 8.13635C5.76572 8.37659 6.14365 8.39525 6.40521 8.19221L6.46803 8.13683L7.99878 6.60874L12.3886 10.9997H9.3347C8.99281 10.9997 8.71103 11.257 8.67252 11.5886L8.66803 11.6663C8.66803 12.0082 8.92539 12.29 9.25695 12.3285L9.3347 12.333H13.9992H9.3347Z",
    fill: "#F64747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendingFilledRed);
export default __webpack_public_path__ + "static/media/arrow_trending_filled_red.9fbeff3d508a753c57e9d92e6daec2c2.svg";
export { ForwardRef as ReactComponent };